import { createSelector } from 'reselect'
import queryString from 'query-string'
import { omit } from 'lodash'

export const getQueryParams = state => state.queryParams

export const getSearchParams = createSelector(
    getQueryParams,
    queryParams => queryParams.search,
)

export const getCollaborativeIndexationIdFromSearchParams = createSelector(
    getSearchParams,
    searchParam => searchParam.collaborativeIndexation,
)

export const getApiFlattenedQueryParams = createSelector(
    getQueryParams,
    getSearchParams,
    (queryParams, searchParams) => {
        let newQueryParams = {}
        if(queryParams.search !== undefined)
        {
            newQueryParams = omit(queryParams, ['search'])
        }

        return {
            ...newQueryParams,
            ...searchParams,
        }
    }
)

export const getApiGroupQueryParams = createSelector(
    getApiFlattenedQueryParams,
    queryParams => omit(queryParams, ['uuid'])
)

export const buildApiGroupQueryString = createSelector(
    getApiGroupQueryParams,
    (state, params) => params || {},
    (apiQueryParams, params) =>  buildQueryString(apiQueryParams, params)
)

export const buildApiContextQueryString = createSelector(
    getApiFlattenedQueryParams,
    (state, params) => params || {},
    (apiQueryParams, params) =>  buildQueryString(apiQueryParams, params)
)

export const buildFrontSearchParamsQueryString = createSelector(
    getSearchParams,
    (state, params) => params || {},
    (searchParams, params) => buildQueryString(searchParams, params)
)

export function buildQueryString(urlParams, customParams)
{
    const queryParams = {
        ...urlParams,
        ...customParams,
    }

    if(Object.keys(queryParams).length === 0)
    {
        return ''
    }

    return '?' + queryString.stringify(queryParams)
}
